import { useState, useEffect } from 'react';
import {Space, Row, Button, Table, Divider, message, PageHeader, Statistic, Card, Col} from 'antd';
import {DeleteOutlined} from '@ant-design/icons';
import AuctionAdd from './AuctionAdd';
import AuctionUpdate from './AuctionUpdate';
import axios from 'axios';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';

const Auction = ()=>{

    const [auctionData, setAuctionData] = useState()
    const [auctionTotal, setAuctionTotal] = useState([])

    const fetchAuction = () =>{
        let getAuction = `${FetchVariable.Heroku}/auction/`
        axios.get(getAuction)
            .then((res)=>{
                let data =res.data
                setAuctionData(data)
                setAuctionTotal(data.length)
            })
        };
    
    function deleteAuction (deleteID){
            let deleteAPI = `${FetchVariable.Heroku}/auction/`+deleteID
            axios.delete(deleteAPI)
                .then(res => {
                    if(res.data.error){
                        let errorMessage = "Can't delete Auction due to Vehicle Constraint"
                        message.error(errorMessage,10);
                    }
                    else {
                        fetchAuction()
                        message.error('The Auction is deleted')
                    }
                })
        };

    const addAuction = (addAuctionData)=>{
            let apiURL = `${FetchVariable.Heroku}/auction/`
            axios.post(apiURL, addAuctionData)
              .then(res=>{
                  if(res.data.error){
                    let errorMessage = (res.data.error).split(" ", 3).join(" ", 3)
                    message.error(errorMessage,10);
                }
                else{
                    fetchAuction()
                }
                }
              ).catch(err=>{console.log(err)})
        };

    const updateAuction = (updateAuction)=>{
            let apiURL= `${FetchVariable.Heroku}/auction/`
            axios.put(apiURL, updateAuction)
                .then(() => {
                    fetchAuction()
                    message.success('Auction Updated!')
                })
                .catch(err=>{console.log(err)})
        };

    useEffect(() => {
        fetchAuction();
    }, [])

    let acutionFilter = []
    auctionData?.forEach((e)=>{acutionFilter.push({text:e.AuctionName,value:e.AuctionName})})
    
        const AuctionColums = [
        {
            title: 'Auction ID',
            dataIndex: 'AuctionID',
            key: 'AuctionID',
            sorter: (a, b) => a.AuctionID - b.AuctionID,
            sortDirections: ['descend','ascend'],
        },
        {
            title: 'Auction Name',
            dataIndex: 'AuctionName',
            key: 'AuctionName',
            filters: acutionFilter,
            filterSearch: true,
            onFilter: (value, record) => record.AuctionName.indexOf(value) === 0,
        },
        {
            title: 'Auction Address',
            dataIndex: 'AuctionAddress',
            key: 'AuctionAddress',
        },
        {
            title: 'Auction Website',
            dataIndex: 'AuctionWebsite',
            key: 'AuctionWebsite',
        },
        {
            title: 'Auction Phone',
            dataIndex: 'AuctionPhone',
            key: 'AuctionPhone',
        },
        {
            title: 'Action',
            key: 'action',
            render: (record) => (
              <Space size="middle">
                <AuctionUpdate record={record} updateAuction={updateAuction}/>
                <Button onClick={()=> deleteAuction(record.AuctionID)} type="primary" danger icon={<DeleteOutlined />}></Button>                
              </Space>
            ),
          },
    ]

    return(
        <>
            <PageHeader
            className="site-page-header"
            title="Auction Management"
            extra={[ 
                <AuctionAdd key='addAuction' addAuction={addAuction}/>,
            ]}
            >
                <Col span={6}>
                    <Card >
                        <Statistic title="Auction Total" value={auctionTotal} />
                    </Card>
                </Col>

            </PageHeader>

            <Divider />
            <Row>
                <Table columns={AuctionColums} dataSource={auctionData} rowKey={(record)=>record.AuctionID} scroll={{ x: 1500, y: 800 }}/>
            </Row>
        </>
    )
}

export default Auction